<template>
  <v-card class="rounded-lg fill-height">
    <v-card-title class="px-6 pt-6 d-flex justify-space-between">
      <div class="subtitle-2 grey--text text--grey-100">
        {{ $t("card_title.player_wellness") }}
      </div>
      <v-btn
        v-if="removable"
        icon
        style="pointer-events: auto"
        @click="$emit('remove')"
      >
        <v-icon small>
          fal fa-times
        </v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text class="text-center pt-6">
      <v-progress-circular
        :value="playerWellnessValue"
        :size="parseInt(height) * 0.8"
        :width="(parseInt(height) - 50) / 10"
        :rotate="-90"
        :color="wellnessColor"
      >
        <div class="text-h4 grey--text text--darken-2">
          {{ playerWellnessValue }}%
        </div>
      </v-progress-circular>
    </v-card-text>
  </v-card>
</template>

<script>
import { getColorForValue } from '@/utils/helpers'

export default {
  name: 'PlayerWellnessChart',
  props: {
    stats: {
      type: Object,
      required: true
    },
    variables: {
      type: Array,
      default: () => []
    },
    event: {
      type: Object,
      default: () => ({})
    },
    player: {
      type: Object,
      default: () => ({})
    },
    height: {
      type: String,
      default: '180'
    },
    removable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    playerWellnessValue() {
      return this.stats.player_wellness || 0
    },
    wellnessColor() {
      return getColorForValue(this.playerWellnessValue, 100)
    }
  },
  methods: {
  }
}
</script>
